import {UsageRecord} from '../types';

const coerceValue = (raw: unknown): number | undefined => {
    if (raw === undefined || raw === null || raw === '') return undefined;
    const n = typeof raw === 'number' ? raw : Number(raw);
    return Number.isFinite(n) ? n : undefined;
};

// Builds the variables payload for the createUsageRecord mutation. Whitelists
// the fields declared on backend CreateUsageRecordInput (usage-records.graphql)
// so that frontend-only fields and server-managed fields (id, updated, user)
// cannot leak into the mutation variables. See FNP-36.
export const buildCreateUsageRecordInput = (values: UsageRecord): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        username: values.username,
        usageType: values.usageType,
        action: values.action,
        recordId: values.recordId,
    };
    const value = coerceValue(values.value);
    if (value !== undefined) input.value = value;
    if (values.recordType !== undefined) input.recordType = values.recordType;
    input.created = values.created ?? new Date().toISOString();
    return input;
};

// Builds the variables payload for the updateUsageRecord mutation. Mirrors the
// create whitelist; UpdateUsageRecordInput does not accept recordType, so we
// drop it. id is required by UpdateUsageRecordInput.
export const buildUpdateUsageRecordInput = (values: UsageRecord): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        id: values.id,
        username: values.username,
        usageType: values.usageType,
        action: values.action,
        recordId: values.recordId,
    };
    const value = coerceValue(values.value);
    if (value !== undefined) input.value = value;
    if (values.updated !== undefined) input.updated = values.updated;
    return input;
};
